"use client";
import React from "react";
import Image from "next/image";
import Link from "next/link";
import { Menu, ShoppingCart } from "lucide-react";
import { Button } from "../ui/button";
import {
  Sheet,
  SheetContent,
  SheetTrigger,
  SheetClose,
  SheetHeader,
  SheetTitle,
} from "../ui/sheet";
import OnlineOrderButton from "../online-order-button";
import ReservationButton from "../reservation-button";
import { useRouter } from "next/navigation";

const Header = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  const router = useRouter();
  const navItems = [
    { id: "home", label: "ACASĂ" },

    { id: "about", label: "Despre noi" },
    { id: "menu", label: "Meniu" },
    { id: "gallery", label: "Galerie" },
    { id: "program", label: "Program" },
    { id: "contact", label: "Contact" },
  ];

  return (
    <header className="fixed left-0 right-0 top-0 z-50 bg-foreground">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-full items-center justify-between">
          {/* Logo */}
          <Link
            href="/"
            className="flex items-center gap-2 focus-visible:outline-none"
            aria-label="Go to home"
          >
            <Image
              src="/images/magic-wok-logo-horizontal.jpeg"
              alt="Magic Wok logo"
              width={250}
              height={48}
              priority
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <Button
                key={item.id}
                variant="ghost"
                size="sm"
                className="rounded-full text-background/80 bg-transparent hover:bg-secondary/90"
                onClick={() => {
                  if (item.id === "home") {
                    router.push("/");
                  } else {
                    scrollToSection(item.id);
                  }
                }}
              >
                {item.label.toUpperCase()}
              </Button>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-2">
            {/* <ReservationButton className="rounded-full" />
            <OnlineOrderButton className="rounded-full" /> */}
          </div>

          {/* Mobile: Menu + Cart */}
          <div className="flex items-center gap-2 md:hidden">
            <Sheet>
              <SheetTrigger asChild>
                <Button
                  variant="ghost"
                  size="icon"
                  className="text-background hover:bg-background/10"
                  aria-label="Open menu"
                >
                  <Menu className="h-5 w-5" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="bg-foreground border-none">
                <SheetHeader>
                  <SheetTitle className="sr-only">
                    Mobile navigation menu
                  </SheetTitle>
                </SheetHeader>
                <div className="mt-6 flex flex-col gap-4">
                  {navItems.map((item) => (
                    <SheetClose asChild key={item.id}>
                      <Button
                        variant="ghost"
                        className="justify-start rounded-full text-background hover:bg-background/10"
                        onClick={() => scrollToSection(item.id)}
                      >
                        {item.label}
                      </Button>
                    </SheetClose>
                  ))}
                  <div className="h-px w-full bg-background/10" />
                  <SheetClose asChild>
                    {/* <ReservationButton className="rounded-full" /> */}
                  </SheetClose>
                  <SheetClose asChild>
                    {/* <OnlineOrderButton className="rounded-full" /> */}
                  </SheetClose>
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
